import { CustomForm } from '@rcp/types';
import { RestSlice } from 'src/redux/rest.slice';
import { Resource, localizationService } from 'src/services';

export const customFormSlice = new RestSlice<CustomForm>(
	localizationService.getLocalizedString('authoritySetting.customForms'),
	`${Resource.Settings}/${Resource.CleaningCustomFormTemplates}`
);
export const customFormReducer = customFormSlice.rests.reducer;
